"use client";

import DynamicForm from "@/components/DynamicForm";
import { RequestDemoFormProps } from "@/types/components";

export default function RequestDemoForm({
  formTitle,
  working_hours_short_version,
}: RequestDemoFormProps) {
  // Note: formTitle and working_hours_short_version were used by the hardcoded form
  // The dynamic form now fetches its configuration from the CMS including title
  // Working hours for date/time fields should be configured in the CMS form config

  // We're keeping the props for backward compatibility but they're not used
  void formTitle;
  void working_hours_short_version;

  return (
    <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-lg">
      <DynamicForm formType="demo" />
    </div>
  );
}
